module.exports = "/_next/static/images/image2-7bff2e7681378bc1d4bdd7776ef8f949.png";